$(document).ready(function () {
  var controller = new ScrollMagic.Controller();
  new ScrollMagic.Scene({
    triggerElement: '.company-contact-info',
    triggerHook: 0.8,
  })
    .setClassToggle('.animate__animated', "showEle") // add class toggle
    //.addIndicators({name: ".company-contact-info "})
    .addTo(controller);
});

import {createApp} from 'vue';
import contactForm from "./ContactForm";

let app = createApp({
  components: {
    'contact-form': contactForm
  }
}).mount('#contact-form-section');

app;
